import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { BehaviorSubject, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { catchError, switchMap, filter, take, map } from 'rxjs/operators';
import { environment } from '../../environments/environment'
import { LoggedInService } from '../services/logged-in.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing: Boolean = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private auth: AuthenticationService,
              private router: Router,
              private loggedIn: LoggedInService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): any {
    if (this.auth.getAccessToken()) {
      request = this.addToken(request, this.auth.getAccessToken());
    }
    return next.handle(request).pipe(catchError((error: any): any => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          if (this.router.url.indexOf('/login/access-denied') === -1) {
            return this.onUnauthorized(request, next)
          } else {
            this.auth.logout();
          }
        } else if (error.status === 403) {
          this.router.navigateByUrl('/login/access-denied')
        } else {
          if (error.url.indexOf(environment.ssoUrl) === -1) {
            alert(error.message)
          } else if (error.url.indexOf(environment.ssoUrl) !== -1 && error.status === 400) {
            this.auth.requestAuthCode(location.origin + this.router.url)
          }
          return throwError(error); 
        }
      } else {
        this.loggedIn.toggle(true);
      }
      return throwError(error);
    }))
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    })
  }

  private onUnauthorized(request: HttpRequest<any>, next: HttpHandler) {

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.auth.refreshAccessToken().pipe(
        switchMap((response: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(response.access_token);
          return next.handle(this.addToken(request, response.access_token));
        })
      )
    } else {
      this.isRefreshing = false;
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(accessToken => {
          return next.handle(this.addToken(request, accessToken))
        })
      )
    }
  }
}
